var colors = /*#__PURE__*/function (colors) {
  colors["neutralWhite"] = "#FFFFFF";
  colors["neutralOffwhite"] = "#FCFCFD";
  colors["neutralBg"] = "#F9FAFB";
  colors["neutralBgHover"] = "#EFF1F5";
  colors["skeletonGradient1"] = "#EFF1F5";
  colors["skeletonGradient2"] = "#DCDFEA";
  colors["neutralLight"] = "#DCDFEA";
  colors["neutralBorder"] = "#B9C0D4";
  colors["neutralBorderHover"] = "#7D89B0";
  colors["neutralTextPlaceholder"] = "#5D6B98";
  colors["neutralTextSubtitle"] = "#4A5578";
  colors["neutralTextBody"] = "#404968";
  colors["neutralTextSection"] = "#30374F";
  colors["neutralTextTitle"] = "#111322";
  colors["brandBlue"] = "#1A3967";
  colors["brandBlueActive"] = "#162146";
  colors["brandBlueHover"] = "#2C3A61";
  colors["brandOrange"] = "#ED7F22";
  colors["brandOrangeActive"] = "#D0650B";
  colors["brandOrangeHover"] = "#E06F10";
  colors["primaryBase"] = "#1652B8";
  colors["primaryBaseActive"] = "#2342BA";
  colors["primaryBaseHover"] = "#3F67D1";
  colors["primaryLight"] = "#9EC4FF";
  colors["primaryLightActive"] = "#7AA9FF";
  colors["primaryLightHover"] = "#B0D2FF";
  colors["secondaryBase"] = "#FFA54A";
  colors["secondaryBaseActive"] = "#FF8D1A";
  colors["secondaryBaseHover"] = "#F09A51";
  colors["secondaryLight"] = "#F3A053";
  colors["secondaryLightActive"] = "#EC7C31";
  colors["secondaryLightHover"] = "#F6B264";
  colors["accentGradient1"] = "#FC987B";
  colors["accentGradient2"] = "#F3A053";
  colors["accentGradientActive1"] = "#FA7355";
  colors["accentGradientActive2"] = "#EC7C31";
  colors["accentGradientHover1"] = "#FDAA8E";
  colors["accentGradientHover2"] = "#F6B264";
  colors["attentionBase"] = "#EDBD43";
  colors["attentionBaseActive"] = "#E3A025";
  colors["attentionBaseHover"] = "#F2CC52";
  colors["attentionText"] = "#404968";
  colors["attentionLight"] = "#F6E3B9";
  colors["attentionLightActive"] = "#B3913E";
  colors["attentionLightHover"] = "#F9EAC8";
  colors["attentionLightText"] = "#404968";
  colors["informationBase"] = "#3B91F1";
  colors["informationBaseActive"] = "#4C89F1";
  colors["informationBaseHover"] = "#49A4F5";
  colors["informationText"] = "#FFFFFF";
  colors["informationLight"] = "#D7E6F7";
  colors["informationLightActive"] = "#C3D8F2";
  colors["informationLightHover"] = "#E1EDF9";
  colors["informationLightText"] = "#4C89F1";
  colors["successBase"] = "#11A76E";
  colors["successBaseActive"] = "#0D734B";
  colors["successBaseHover"] = "#14B87F";
  colors["successText"] = "#FFFFFF";
  colors["successLight"] = "#B1EFCD";
  colors["successLightActive"] = "#90E6B5";
  colors["successLightHover"] = "#C3F4DA";
  colors["successLightText"] = "#0D734B";
  colors["warningBase"] = "#BB1139";
  colors["warningBaseActive"] = "#9D071E";
  colors["warningBaseHover"] = "#CA1646";
  colors["warningText"] = "#FFFFFF";
  colors["warningLight"] = "#F8DDE2";
  colors["warningLightActive"] = "#F4CBD3";
  colors["warningLightHover"] = "#FAE7E9";
  colors["warningLightText"] = "#BB1139";
  colors["dvResolutionBlue"] = "#2B3D6B";
  colors["dvSlateBlue"] = "#5B62D5";
  colors["dvSkyBlue"] = "#9BBFF7";
  colors["dvRomanRed"] = "#D75D64";
  colors["dvCeladonGreen"] = "#A5DEAF";
  colors["dvTrueViolet"] = "#8F72CB";
  colors["dvJordyBlue"] = "#969BEA";
  colors["dvCherokeeYellow"] = "#F3D383";
  colors["dvCrustaOrange"] = "#F18765";
  colors["dvLochinvarGreen"] = "#488A7A";
  colors["dvFeijoaGreen"] = "#B0DC77";
  colors["white"] = "#fff";
  colors["ultraLightGray"] = "#f9f9f9";
  colors["lightGray"] = "#ebebeb";
  colors["gray"] = "#ccc";
  colors["firstGray"] = "#9b9b9b";
  colors["secondGray"] = "#838181";
  colors["darkGray"] = "#333";
  colors["middleGray"] = "#666";
  colors["tableBorderGray"] = "#ececec";
  colors["backgroundBlue"] = "#f1f4f9";
  colors["veryLightBlue"] = "#e6edf2";
  colors["emptyStateBlue"] = "#cbdcf8";
  colors["account"] = "#c4ccd8";
  colors["darkSlateBlue"] = "#1a3967";
  colors["lightBlue"] = "#1b56b2";
  colors["middleBlue"] = "#5383e5";
  colors["darkBlue"] = "#222941";
  colors["yellow"] = "#eeb711";
  colors["green"] = "#51ae37";
  colors["secondGreen"] = "#6da15e";
  colors["red"] = "#c93b3b";
  colors["redHover"] = "#de5757";
  colors["dustyOrange"] = "#ed7f22";
  colors["dustyOrangeAccent"] = "#dd6b0b";
  return colors;
}(colors || {});
export default colors;